import { render, staticRenderFns } from "./product_brand.vue?vue&type=template&id=203f4229"
import script from "./product_brand.vue?vue&type=script&lang=js"
export * from "./product_brand.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports